import cookie from '@tencent/vft-common/cookie';
import { loadScript, sleep } from '@tencent/vft-common/util.esm';

import { syncCookies } from '../lib';
import { LOGIN_TYPE } from './config';
import { setUserInfo } from './helper';
import * as reporter from './report';
import { authLogin } from './service';

export function requestQQLogin(params) {
  return authLogin({
    type: LOGIN_TYPE.qq,
    appid: '101527197',
    raw: 1,
    clear: '1',
    ...params,
  });
}

// 获取QQ的本地 openapi 授权
export function requestQQNativeAuth() {
  return new Promise((resolve, reject) => {
    const isInIframe = typeof window !== 'undefined' && window !== window.top;
    // 如果NativeApi加载失败，或者不触发回调，需要一个超时兜底逻辑，避免login.init回调无法触发
    const timer = setTimeout(() => {
      reporter.report({ f_event: reporter.EVENT_MQQ_NATIVE_LOGIN_TIMEOUT });
      reject(new Error('[login/lib/requestQQNativeAuth]QQNativeAuth timeout(5000ms)'));
    }, 5000); // 授权超时时长
    loadScript('https://g.gtimg.cn/libs/nativeapi/v1.0.0/Native.js', { injectParent: isInIframe }).then(() => {
      // QQ的NativeApi判断如果不在top window中，invoke方法会直接返回null，不执行任何回调，因此必须在top window中加载
      const NativeApi = isInIframe ? window.top.NativeApi : window.NativeApi;
      if (!NativeApi) {
        clearTimeout(timer);
        reporter.report({ f_event: reporter.EVENT_MQQ_NATIVE_LOGIN_LOAD_JSAPI_FAIL });
        reject(new Error('[login/lib/requestQQNativeAuth]NativeApi not found'));
        return;
      }
      // eslint-disable-next-line no-undef
      NativeApi.invoke('config', {
        appid: '101527197',
        permission(err) {
          clearTimeout(timer);
          reject(err);
        },
        success() {
          clearTimeout(timer);
          // eslint-disable-next-line no-undef
          NativeApi.invoke('loginSilent', {
            success(data) {
              resolve({
                access_token: data.access_token,
                openid: data.openid,
              });
            },
            failure(err) {
              reject(err);
            },
          });
        },
        failure(err) {
          clearTimeout(timer);
          reject(err);
        },
      });
    });
  });
}

/**
 * QQLogin openid,access_token换视频票据
 */
export async function openNativeLogin() {
  reporter.report({
    f_event: reporter.EVENT_LOGIN_START,
  });

  const authParams = await requestQQNativeAuth();
  const loginInfo = await requestQQLogin(authParams);
  setUserInfo(loginInfo, LOGIN_TYPE.qq);

  // 清掉 uin/skey 票据，避免与互联票据重复
  ['uin', 'skey'].forEach(key => cookie.remove(key, { domain: 'qq.com', path: '/' }));

  // iOS 手Q会有 webview 读 cookie 延迟问题，跟 JS 线程同步有关
  await sleep(10);
  await syncCookies();
}

/**
 * 手Q内静默授权登录
 */
export async function handleMqqLogin() {
  try {
    await openNativeLogin();
    reporter.report({
      f_event: reporter.EVENT_LOGIN_AUTH,
      f_cgi: 'NewLogin',
      f_errcode: 0,
    });
  } catch (e) {
    // 异常无须处理只上报，当做未登录，用户可以进入登录页重新登录
    reporter.report({
      f_event: reporter.EVENT_LOGIN_FAIL,
      f_cgi: 'NewLogin',
      f_errcode: e.code,
      f_errmsg: e.msg,
    });
    throw e;
  }
}
